
export const state = {
    vModel: {
        adminDetails:{},
        businessDetails:{},
        mailingAddress:{
            AddressLine1:'',
            AddressLine2:'',
            PostalCode:'',
            State:'',
            City:'',
            CountryOfResidence:'MY',
            Country:'Malaysia'
        },
        businessAddress:{
            AddressLine1:'',
            AddressLine2:'',
            PostalCode:'',
            State:'',
            City:'',
            CountryOfResidence:'MY',
            Country:'Malaysia'
        },
        directorDetails:[{
            fullName:null,
            email:null,
            idTypeId:null,
            idNumber:'',
            nationalityId:'',
            dateOfBirth:''
        }],
        shareHolderDetails:[{
            shareHolderTypeId:1,
            fullName:'',
            email:'',
            idTypeId:null,
            idNumber:'',
            nationalityId:null,
            dateOfBirth:''
        
        }],
    }
}

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        for( const key in newValue){
            console.log('store')
            console.log(`${key}:${newValue[key]}`)
            state.vModel[key]= newValue[key]
        }
        saveState('registration', newValue)
    }
}

export const getters = {
    // Whether the user is currently logged in.
    getUserInfo(state) {
        return state
    }
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {
        //dispatch('validate')
    },
    updateUserInfo({commit},payload){
        commit('SET_CURRENT_USER',payload)
    },
}

// ===
// Private helpers
// ===

function saveState(key, state) {
    window.sessionStorage.setItem(key, JSON.stringify(state))
}
